import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { browserHistory } from 'react-router'
import { getNewProposalInfo } from '../../user/actions/GetInfo'
import { sendRawTransaction } from '../../user/actions/transactions/NewProposal'
import { clearTransaction } from '../../user/actions/transactions/Clear'
import { connect } from 'react-redux'
import {
  Container,
  Segment,
  Header,
  Form,
  Button,
  Message,
  Modal
} from 'semantic-ui-react'
import lightwallet from 'eth-lightwallet'
import store from '../../store'

class NewProposal extends Component {
	
    constructor(props) {
        super(props)
	
        this.state = {
            proposalInputAddress: '',
            proposalInputFee: '',
            proposalInputMinimumVotes: '',
            proposalInputMinutes: '',
            proposalInputDescription: '',
            proposalWithoutRecipient: false,
            errorMessage: false,
            errorMessageText: '',
            showModal: false,
            checkPassword: '',
            checkConfirmPassword: '',
            web3: store.getState().web3.web3Instance
        }
    }
	
    componentWillMount(){
		
        let { dispatch, memberId, balanceIn, balanceInToken, authData } = this.props
		
        if(memberId === '0' || balanceIn === '0 ETH' || balanceInToken === '0 ETH'){
            return browserHistory.push('/city')
        }

        let ks = lightwallet.keystore.deserialize(authData.keystore)
        let address = ks.getAddresses()

        dispatch(getNewProposalInfo(address[0]))
    }
	
    componentWillReceiveProps(nextProps){

        let { showHashModal, memberId, balanceIn, balanceInToken  } = nextProps

        if(memberId === '0' || balanceIn === '0 ETH' || balanceInToken === '0 ETH'){
            return browserHistory.push('/city')
        }

        if(showHashModal){
            this.setState({ showModal: false, checkPassword:'', checkConfirmPassword:''})
        }

    }

    transactionIsDone(){

        let { dispatch } = this.props

        dispatch(clearTransaction())
        
        browserHistory.push('/city')
    }
	
    checkPasswordOnInputChange(event) {
        this.setState({ checkPassword: event.target.value})
    }
	
    checkPasswordConfirmOnInputChange(event) {
        this.setState({ checkConfirmPassword: event.target.value})
    }
	
    proposalAddressOnInputChange(event) {
        this.setState({ proposalInputAddress: event.target.value })
    }
	
    proposalFeeOnInputChange(event) {
        this.setState({ proposalInputFee: event.target.value })
    }
	
    proposalMinimumVotesOnInputChange(event) {
        this.setState({ proposalInputMinimumVotes: event.target.value })
    }
	
    proposalMinutesOnInputChange(event) {
        this.setState({ proposalInputMinutes: event.target.value })
    }
	
    proposalDescriptionOnInputChange(event) {
        this.setState({ proposalInputDescription: event.target.value })
    }
	
    between(x, min, max) {
        return x >= min && x <= max;
    }
	
    inputProposalSubmit(event) {
        event.preventDefault()
        
        let { dispatch } = this.props

        let { proposalInputFee, proposalInputAddress, proposalInputMinutes, proposalInputMinimumVotes, proposalInputDescription } = this.state

        let that = this
		
        let isChecksumAddress = function (address) {
			// Check each case
            address = address.replace('0x','');
            let addressHash = that.state.web3.sha3(address.toLowerCase());

            for (let i = 0; i < 40; i++ ) {
				// the nth letter should be uppercase if the nth digit of casemap is 1
                if ((parseInt(addressHash[i], 16) > 7 && address[i].toUpperCase() !== address[i]) || (parseInt(addressHash[i], 16) <= 7 && address[i].toLowerCase() !== address[i])) {
                    return false;
                }
            }
            return true;
        }
				
        let isAddress = function (address) {
            if (!/^(0x)?[0-9a-f]{40}$/i.test(address)) {
				// check if it has the basic requirements of an address
                return false;
            } else if (/^(0x)?[0-9a-f]{40}$/.test(address) || /^(0x)?[0-9A-F]{40}$/.test(address)) {
				// If it's all small caps or all all caps, return true
                return true;
            } else {
				// Otherwise check each case
                return isChecksumAddress(address);
            }
        }
		
        if(!this.state.proposalWithoutRecipient){
            if (!this.between(proposalInputFee, 0.01, 100)){
                return this.setState({ errorMessage: true, errorMessageText: 'Your fee should be between 0.01 and 100 ETH.' })
            }
			
            if (!isAddress(proposalInputAddress.toLowerCase())){
                return this.setState({ errorMessage: true, errorMessageText: 'Enter valid address.' })
            }
        }
		
        if (!this.between(proposalInputMinimumVotes, 1, 1000000000)){
            return this.setState({ errorMessage: true, errorMessageText: 'Minimum votes should be between 1 and 1000000000.' })
        }
		
        if (!this.between(proposalInputMinutes, 1, 10080)){
            return this.setState({ errorMessage: true, errorMessageText: 'Minutes to vote should be between 1 and 10080 (1 week).' })
        }

        if (proposalInputDescription.trim() === ''){
            return this.setState({ errorMessage: true, errorMessageText: 'Your description is empty.' })
        }		
		
        dispatch(clearTransaction())

        this.setState({ errorMessage: false, showModal: true})
    }
	
    checkPasswordSubmitProposal(event) {
        event.preventDefault()
        
        let { checkPassword, checkConfirmPassword, proposalWithoutRecipient, proposalInputFee, proposalInputAddress, proposalInputMinutes, proposalInputMinimumVotes, proposalInputDescription } = this.state

        let { dispatch, authData } = this.props

        let keystore = authData.keystore
       
        dispatch(sendRawTransaction(keystore, proposalWithoutRecipient, proposalInputFee, proposalInputAddress, proposalInputMinutes, proposalInputMinimumVotes, proposalInputDescription, checkPassword, checkConfirmPassword))  

    }

	
    render() {

        let { errorMessage, errorMessageText, showModal, proposalWithoutRecipient, proposalInputFee, proposalInputAddress, proposalInputMinimumVotes, proposalInputMinutes, proposalInputDescription, checkPassword, checkConfirmPassword } = this.state

        let { memberId, balanceIn, balanceInToken, checkLoading, checkErrorMessage, checkErrorMessageText, showHashModal, transactionHash } = this.props

        if(memberId === 'N-N' || balanceIn === 'N-N' || balanceInToken === 'N-N'){
            return(<Segment style={{  minHeight: 700 }} vertical loading />)
        }

        if(memberId !== '0' || balanceIn !== '0 ETH' || balanceInToken !== '0 ETH'){

            return(
                <Segment textAlign='center' style={{  minHeight: 700, paddingTop: '1em', paddingBottom: '4em' }} vertical>
                    <Header as='h1' style={{fontSize: '4em',fontWeight: 'normal',marginBottom: '1em',marginTop: '1em'}}>
						New Proposal
                    </Header>
                    <Container textAlign='left' text>
                        <Message error hidden={!errorMessage} content={errorMessageText}/>
                        <Form size='large' onSubmit={this.inputProposalSubmit.bind(this)}>
                            <Form.Group>
                                <Form.Input disabled={proposalWithoutRecipient} value={proposalInputFee} onChange={this.proposalFeeOnInputChange.bind(this)} fluid label='ETH Amount' placeholder='Enter fee' type="number" step="0.01" min="0.01" max="100" width={6} />
                                <Form.Input disabled={proposalWithoutRecipient} value={proposalInputAddress} onChange={this.proposalAddressOnInputChange.bind(this)} fluid label='Recipient address' placeholder='Enter recipient address' width={10} />
                            </Form.Group>
                            <Form.Checkbox onChange={() => this.setState({proposalWithoutRecipient:!proposalWithoutRecipient})} label='Without recipient' />
                            <Form.Group widths='equal'>
                                <Form.Input value={proposalInputMinimumVotes} onChange={this.proposalMinimumVotesOnInputChange.bind(this)} fluid label='Minimum votes' placeholder='Enter number' type="number" step="1" min="1" max="1000000000" />
                                <Form.Input value={proposalInputMinutes} onChange={this.proposalMinutesOnInputChange.bind(this)} fluid label='Amount minutes to vote' placeholder='Enter minutes' type="number" step="1" min="1" max="10080"/>
                            </Form.Group>
                            <Form.TextArea label='Description' value={proposalInputDescription} onChange={this.proposalDescriptionOnInputChange.bind(this)} placeholder='Tell about the problem...' />
                            <Button.Group size='large'>
                                <Button positive type='submit'>Submit</Button>
                            </Button.Group>
                        </Form>
                    </Container>
                    <Modal size='mini' open={showModal} closeOnEscape={!checkLoading} closeOnRootNodeClick={!checkLoading} onClose={() => this.setState({showModal:false, checkPassword:'', checkConfirmPassword:''})} closeIcon={!checkLoading}>
                        <Modal.Header>
							Confirm your password
                        </Modal.Header>
                        <Modal.Content>
                            <Message error hidden={!checkErrorMessage} content={checkErrorMessageText}/>
                            <Form size='small' onSubmit={this.checkPasswordSubmitProposal.bind(this)} loading={checkLoading}>
                                <Form.Field>
                                    <label>Password</label>
                                    <input type='password' minLength='6' autoComplete='new-password' placeholder='Password' value={checkPassword} onChange={this.checkPasswordOnInputChange.bind(this)} />
                                </Form.Field>
                                <Form.Field>
                                    <label>Confirm Password</label>
                                    <input type='password' minLength='6' autoComplete='current-password' placeholder='Confirm Password' value={checkConfirmPassword} onChange={this.checkPasswordConfirmOnInputChange.bind(this)} />
                                </Form.Field>
                                <Button.Group size='small'>
                                    <Button positive type='submit'>Submit</Button>
                                </Button.Group>
                                <p style={{fontSize: '0.7em'}}>* The transaction can take about a minute</p>
                            </Form>
                        </Modal.Content>
                    </Modal>
                    <Modal basic size='small' open={showHashModal} onClose={() => this.transactionIsDone()} closeIcon>
                        <Header content='Transaction Hash' />
                        <Modal.Content>
                            <p>Transaction successfully processed. <a href={'https://rinkeby.etherscan.io/tx/'+transactionHash} target="_blank">Here</a> you can find all information about it.</p>
                        </Modal.Content>
                    </Modal>
                </Segment>
                )
        } else {
            return (null)
        }
    }
}

const mapStateToProps = (state) => {
    return {
        memberId: state.city.data.memberId,
        balanceIn: state.city.data.balanceIn,
        balanceInToken: state.city.data.balanceInToken,
        checkLoading: state.transaction.data.checkLoading,
        checkErrorMessage: state.transaction.data.checkErrorMessage,
        checkErrorMessageText: state.transaction.data.checkErrorMessageText,
        showHashModal: state.transaction.data.showHashModal, 
        transactionHash: state.transaction.data.transactionHash
    }
}

export default connect(mapStateToProps)(NewProposal)


NewProposal.propTypes = {
    memberId: PropTypes.string,
    balanceIn: PropTypes.string,
    balanceInToken: PropTypes.string,
    authData: PropTypes.object,
    dispatch: PropTypes.func,
    checkLoading: PropTypes.bool,
    checkErrorMessage: PropTypes.bool,
    checkErrorMessageText: PropTypes.string,
    showHashModal: PropTypes.bool, 
    transactionHash: PropTypes.string
}


// WEBPACK FOOTER //
// ./src/layouts/city/NewProposal.js